// extracted by mini-css-extract-plugin
export default {"root":"Wrapper_root__I4nOa"};